import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";

interface EditorComponentProps {
  text: string;
  onContentChange?: (content: string) => void;
  readOnly?: boolean;
}

const EditorComponent = ({
  text,
  onContentChange,
  readOnly = false,
}: EditorComponentProps) => {
  const [editorState, setEditorState] = useState<EditorState>(() => {
    if (text) {
      const contentBlock = htmlToDraft(text);
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      return EditorState.createWithContent(contentState);
    } else {
      return EditorState.createEmpty();
    }
  });

  const onEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);
    const content = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    onContentChange && onContentChange(content);
  };

  useEffect(() => {
    if (text) {
      const contentBlock = htmlToDraft(text);
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      const newEditorState = EditorState.createWithContent(contentState);

      // Compara el contenido actual del editor con el nuevo contenido
      if (
        !editorState ||
        draftToHtml(convertToRaw(editorState.getCurrentContent())) !== text
      ) {
        setEditorState(newEditorState);
      }
    }
  }, [text]);

  const toolbarConfig = {
    link: {
      defaultTargetOption: "_blank",
    },
  };

  return (
    <Editor
      spellCheck={true}
      editorState={editorState}
      readOnly={readOnly}
      wrapperStyle={{ height: "calc(100% - 36px)" }}
      editorStyle={{
        backgroundColor: "var(--bo-card-bg)",
        color: "var(--bo-text)",
        padding: 10,
        height: "100%",
        border: "1px solid var(--bo-border-strong)",
        overflowY: "auto",
      }}
      wrapperClassName="wrapper-class"
      editorClassName="editor-class"
      toolbarClassName="toolbar-class"
      toolbarHidden={readOnly}
      toolbar={toolbarConfig}
      localization={{
        locale: "es",
      }}
      onEditorStateChange={onEditorStateChange}
    />
  );
};

export default EditorComponent;
